import React from 'react';
import Signup from '../../../components/SignUpScreen/SignUpScreen';

const SignupPage = () => {
  return <Signup />;
};

export default SignupPage;
